<template>
  <div>
    <toggle-btn
      block
      class="mb-2"
      :disabled="disabled"
      icon="mdi-weather-sunny"
      label="Morning"
      val="am"
      :model-value="deliveryTime"
      @update:model-value="updateDeliveryTime"
    />
    <toggle-btn
      block
      class="mb-2"
      :disabled="disabled"
      icon="mdi-weather-sunset"
      label="Afternoon"
      val="pm"
      :model-value="deliveryTime"
      @update:model-value="updateDeliveryTime"
    />
    <time-picker
      v-bind="$attrs"
      class="mt-2"
      :disabled="disabled"
      :model-value="modelValue"
      @update:delivery-time="updateDeliveryTime"
      @update:model-value="$emit('update:model-value', $event)"
    />
  </div>
</template>

<script>
import { DateTime } from '@quotetome/materials-api'
import TimePicker from '@/components/time-picker.vue'
import ToggleBtn from '@/components/toggle-btn.vue'

export default {
  name: 'order-delivery-time',
  components: { TimePicker, ToggleBtn },
  props: {
    deliveryTime: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: undefined
    },
  },
  emits: ['update:delivery-time', 'update:model-value'],
  methods: {
    updateDeliveryTime(value) {
      this.$emit('update:delivery-time', value)

      if ((value === 'am' || value === 'pm') && this.modelValue) {
        this.$emit('update:model-value', new DateTime(this.modelValue).withHour(12).withMinute(0))
      }
    }
  },
}
</script>
